/** A header with a trailing count link, over a bound list of divided `card` rows. */
import { useState } from 'react';
import { Surface, Vertical } from './primitives';
import { PanelHeader } from './panelHeader';
import { ItemCollection } from './collections';

export function ActivityShelf({ nodeId, node, props = {}, data, ctx, emit, slots, renderTemplate }) {
  const cap = Number(props.limit) > 0 ? Number(props.limit) : 0;
  const [open, setOpen] = useState(false);
  const action = props.action || null;

  const reveal = () => {
    setOpen((v) => !v);
    emit?.('actionActivated', { action: action?.action || action?.label || null });
  };

  return (
    <Surface variant="card" props={{ padding: '4', radius: 28 }}>
      <Vertical props={{ gap: '3' }}>
        <PanelHeader title={props.title} action={action} onAction={reveal} />
        <ItemCollection
          nodeId={nodeId}
          node={node}
          props={{
            layout: 'list',
            // A hairline is what separates one entry from the next in a feed —
            // a grid's gutters already say where a cell ends, a list has none.
            divided: true,
            // The panel opens on a GLANCE; the header's own link is what turns
            // it into the whole feed, so the cap lives here, not on the caller.
            limit: open ? 0 : cap,
            items: props.items,
            card: props.card,
            emptyTitle: props.emptyTitle,
            emptyBody: props.emptyBody,
          }}
          data={data}
          ctx={ctx}
          emit={emit}
          slots={slots}
          renderTemplate={renderTemplate || props.renderTemplate}
        />
      </Vertical>
    </Surface>
  );
}

export default ActivityShelf;
